import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors, Gradients } from '../../styles/colors';
import { FlexboxCenter, Flexbox, FlexContainer } from './Layout';
import { UserState } from '../../state/UserState';
import { useRecoilValue } from 'recoil';

const Root = styled(Flexbox)`
  margin: -1rem 0 0;
  height: 10rem;
  align-items: stretch;

  @media (min-width: 1400px) {
    margin: -1rem -2rem 0;
  }
`;
const Text = styled(FlexboxCenter)`
  position: relative;
  align-items: flex-start;
  height: 100%;
  overflow: auto;

  padding: 2rem;

  background: ${Gradients.buttonPrimary};
  color: ${Colors.white};

  font-weight: 700;
  font-size: 2.125rem;
  line-height: 1.06;
`;
const Image = styled.img`
  flex: 1 0 0%;
  min-width: 0;

  object-fit: cover;
`;
const Chevron = styled.div`
  position: absolute;
  bottom: 0;
  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-bottom: 1rem solid ${Colors.background};
`;

interface Props {
  image: string;
}
export const DashboardHead: FC<Props> = ({ image }) => {
  const user = useRecoilValue(UserState);

  return (
    <Root>
      <FlexContainer>

        <Text>
          Herzlich Willkommen<br/>
          { user.current?.firstName } { user.current?.familyName }
          <Chevron />
        </Text>
      </FlexContainer>
      <Image src={image} alt="" />
    </Root>
  );
};
